<div class="cell-container" [ngClass]="{'blur': blur()}" >
  <div class="share-bar-container">
    <div
      class="share-bar-fill"
      [ngStyle]="{'width': barWidth, 'background-color': color}">
    </div>
    <ng-content *ngIf="focus()">
      <div>
        <span class="value">{{ addPercent(round(value, 1)) }}</span>
      </div>
    </ng-content>
  </div>
</div>
